import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAOYwb7UMioo2r63hVSZFqdbC_kVhsFwb0",
    authDomain: "navigate-37085.firebaseapp.com",
    projectId: "navigate-37085",
    storageBucket: "navigate-37085.appspot.com",
    messagingSenderId: "718704504950",
    appId: "1:718704504950:web:84e0e18fa548d186d42f57",
    measurementId: "G-W5P3TNH17F"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
export default auth